import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'
import { Edit, Delete, Add, Close } from '@material-ui/icons'

import { TextField } from '@material-ui/core'
import { observer } from 'mobx-react'
import useStore from 'store'

import Close1Icon from 'assets/icons/ims/Close2.svg'
import EmergencyIcon3 from 'assets/icons/ims/EmergencyIcon3.svg'

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 31.989px;
  flex-shrink: 0;display: flex;
  min-height: 186.932px;
  padding: 23.991px 23.991px 0 23.991px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  background: #FFF;
`
const DialogBody = styled(DialogContent)`
  background: white;
  border-top-width: 1px;
  overflow-y: none;
`
const TopContainer = styled.div`
  display: flex;
  min-height: 82.969px;
  padding-right: 0;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const ConfirmButton = styled(Button)`
  display: flex;
  height: 40px;
  padding: 7px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #FFF;
  border-radius: 6px;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const CancelButton = styled(Button)`
  display: flex;
  padding: 8.724px 15.875px 7.276px 15.994px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #F1F5F9;
  color: #0F172A;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const CloseButton = styled(Button)`
  min-width: 0px;
  padding: 0px;
`
const ImageIcon = styled(Image)`
  display: flex;
  width: 27.983px;
  height: 27.983px;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
`

const TopHeader = styled.div`
  display: flex;
  min-height: 82.969px;
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
  flex: 1 0 0;
`
const TopHeader1 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #0F172A;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
`
const TopHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  text-align: right; 
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

const ConfirmationDialog = ({ 
  open, 
  closeModal, 
  onConfirm, 
  TitleMain, 
  TitleSecond, 
  confirmBtnColor,
  ConfirmButtonText,
  CancelButtonText, 
}) => {
  const { members, orgs, uiStore, memberStore } = useStore()
  const { t } = useTranslation('members')

  return (
    <>
        <Dialog style={{ zIndex: 1200 }} open={open} maxWidth={'lg'}>
            <DialogBody>
                <BodyContainer>
                    <TopContainer>
                        <TopHeader>
                          <TopHeader1>{TitleMain}</TopHeader1>
                          <TopHeader2>{TitleSecond}</TopHeader2>
                        </TopHeader>
                        <CloseButton onClick={() => closeModal(false)}>
                            <ImageIcon src={Close1Icon}/>
                        </CloseButton> 
                    </TopContainer>
                    <BottomContainer>
                      <CancelButton onClick={() => closeModal(false)}>{CancelButtonText}</CancelButton>
                      <ConfirmButton style={{ background: confirmBtnColor }} onClick={() => { onConfirm() }}>{ConfirmButtonText}</ConfirmButton> 
                    </BottomContainer>
                </BodyContainer>
            </DialogBody>
        </Dialog>
    </>
  )
}

export default observer(ConfirmationDialog)


